module.exports = __webpack_public_path__ + "static/media/moogle.51cdcc8e.svg";